import React, { Fragment} from 'react';
import { useStyle } from './style';
import {Paper, Grid} from '@material-ui/core';
import {EirAddressFinder} from '../eir-checkout/EirAddressFinder';
export default function EirAddressFinderContainer(props) {
	const classes = useStyle();
	return (
		<Fragment>
            <Grid item sm={12} className={classes.personalPadding}>
                <Paper className={classes.contactPaper} variant='elevation' elevation={4}>
                    <Grid container>
                        <Grid item sm={12}>
                            <h2 className={classes.contactTxt}>
                            Installation Address Finder
							</h2>
                        </Grid> 
                        <Grid container sm={12}>
                            <EirAddressFinder/>
                        </Grid>           
                    </Grid>
                </Paper>
            </Grid>
		</Fragment>
	);
}